// extracted by mini-css-extract-plugin
export default {"chat-container":"active-chat_chat-container__3eoHt"};